import React from 'react';
import { default as ReactCalendar } from 'react-calendar';
import { OnChangeDateCallback, OnChangeDateRangeCallback } from 'react-calendar';
import styles from './DatePicker.module.css';
import 'react-calendar/dist/Calendar.css';
import './DatePicker.override.css';
import { ReactComponent as ArrowIcon } from '../../../../assets/Chevron.svg';

export type DatePickerProps =
    | {
          value: Date | null | undefined;
          onChange: OnChangeDateCallback;
          selectRange?: false;
      }
    | {
          value: [Date] | [Date, Date] | null | undefined;
          onChange: OnChangeDateRangeCallback;
          selectRange: true;
      };

const DatePicker = ({ value, onChange, selectRange = false }: DatePickerProps) => {
    return (
        <ReactCalendar
            locale="en-GB"
            maxDetail="month"
            prevLabel={<ArrowIcon className={styles.prevLabel} />}
            nextLabel={<ArrowIcon className={styles.nextLabel} />}
            prev2Label={null}
            next2Label={null}
            value={value}
            onChange={onChange}
            selectRange={selectRange}
        />
    );
};

export default DatePicker;
